import { useEffect } from "react";
import { VStack, HStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";

import { useStores } from "../store/store_context";
import FiltersGrid from "../components/filters_grid";
import TableData from "../components/overdue_receivables_page/table_data";

// «Просроченная ДЗ (ПДЗ)» — аналог инструмента в Б24. Данные — из «Счетов»,
// отбор и расчёт на бэкенде (/api/overdue_receivables).
const OverdueReceivablesPage = observer(() => {
  const { pageStore } = useStores();

  useEffect(() => {
    pageStore.getAllManagers();
    pageStore.getAllDepartments();
    pageStore.getAllPartners();
    pageStore.getAllBackups();
    pageStore.resetFilters();
  }, []);

  useEffect(() => {
    pageStore.updateSelectedPage("/overdue");
  }, []);

  return (
    <VStack width={"100%"} align={"flex-start"}>
      <HStack
        width="100%"
        spacing="12px"
        wrap="wrap"
        padding="0 20px"
        marginTop="20px"
        justify="center"
      >
        <FiltersGrid page="overdue" renderButtons={(buttons) => buttons} />
        <TableData data={pageStore.data_overdue} renderButtons={(buttons) => buttons} />
      </HStack>
    </VStack>
  );
});

export default OverdueReceivablesPage;
